// extracted by mini-css-extract-plugin
export default {"Faq":"faq_Faq__IPHfX"};